import auth from '@/Middlewares/auth.js'
import ResourceRoute from '@/Setup/Routes/ResourceRoute.js'
import RouteGroup from '@/Setup/Routes/RouteGroup.js'

export const reportRoutes = new RouteGroup(() => {
  return [
    ...new ResourceRoute('reports', {
      show: () => import(/* webpackChunkName: "admin" */ './Pages/Show.vue'),
      list: () => import(/* webpackChunkName: "admin" */ './Pages/List.vue'),
      edit: () => import(/* webpackChunkName: "admin" */ './Pages/Edit.vue'),
    })
      .permissions({
        show: 'reports.view',
        list: 'reports.view',
        edit: 'reports.update',
      })
      .only(['list', 'show', 'edit'])
      .resolve(),
  ]
})
  .middlewares([auth])
  .resolve()
